export function appointmentIndexValidate(appointment){
    var result = true;

    result = validateId(appointment.id);
    if(!result) return result;
    
    result = validateArrivalDate(appointment.arrival_date);
    if(!result) return result;

    result = validateContainerNumber(appointment.container_number);
    if(!result) return result;

    result = validateDescription(appointment.description);
    if(!result) return result;

    result = validateCommentary(appointment.commentary);
    if(!result) return result;

    result = validateStatus(appointment.status);
    if(!result) return result;

    result = validateFilesStatus(appointment.files_status);
    if(!result) return result;

    result = validateIsNational(appointment.is_national);
    if(!result) return result;

    result = validateClient(appointment.client);
    if(!result) return result;
    
    result = validateUser(appointment.user);
    if(!result) return result;

    result = validateOperation(appointment.operation);
    if (!result) return result;

    result = validateWarehouse(appointment.warehouse);
    
    return result;
}

function validateId(id) {
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateArrivalDate(arrival_date) {
    return (typeof arrival_date === 'string');
}

function validateContainerNumber(container_number) {
    return ((typeof container_number === 'string' 
        && container_number.trim() !== "") || container_number.trim() == "");
}

function validateDescription(description) {
    return (typeof description === 'string');
}

function validateCommentary(commentary) {
    return (typeof commentary === 'string');
}

function validateStatus(status) {
    return (typeof status === 'string' 
        && status.trim() !== "");
}

function validateFilesStatus(files_status) {
    return (typeof files_status === 'string' 
        && files_status.trim() !== "");
}

function validateIsNational(is_national) {
    return (typeof is_national === 'boolean');
}

function validateClient(client) {
    return (typeof client === 'object' 
        && Number.isInteger(client.id)
        && typeof client.name === 'string' 
        && client.name.trim() !== ""
    );
}

function validateUser(user) {
    return (typeof user === 'object' 
        && Number.isInteger(user.id)
        && typeof user.name === 'string' 
        && user.name.trim() !== ""
        && typeof user.paternal_surname === 'string' 
    );
}

function validateOperation(operation) {
    return (typeof operation === 'object'
        && Number.isInteger(operation.id)
        && typeof operation.description_en === 'string' 
        && operation.description_en.trim() !== ""
        && typeof operation.description_es === 'string' 
        && operation.description_es.trim() !== ""
        && typeof operation.format_type === 'string' 
        && operation.format_type.trim() !== ""
    )
}

function validateWarehouse(warehouse) {
    return (typeof warehouse === 'object'
        && Number.isInteger(warehouse.id)
        && typeof warehouse.name === 'string'
        && warehouse.name.trim() !== ""
        && (typeof warehouse.picking_required === 'boolean' || Number.isInteger(warehouse.picking_required))
    )
}